var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSavedCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.32 3.20001H3.67998C2.52558 3.20001 1.61038 4.12561 1.61038 5.28001L1.59998 17.76C1.59998 18.9144 2.52558 19.84 3.67998 19.84H7.42664V19.7067C7.42664 18.931 7.93784 18.2819 8.70821 17.76H3.67998V11.52H11.2593C11.8145 10.2483 13.083 9.36001 14.56 9.36001C16.0369 9.36001 17.3054 10.2483 17.8607 11.52H20.32V17.7521C20.997 18.208 21.4762 18.7616 21.5882 19.4123C22.0828 19.0331 22.4 18.4358 22.4 17.76V5.28001C22.4 4.12561 21.4744 3.20001 20.32 3.20001ZM20.32 7.36001H3.67998V5.28001H20.32V7.36001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.56 15.6C16.0186 15.6 17.2 14.4186 17.2 12.96C17.2 11.5014 16.0186 10.32 14.56 10.32C13.1014 10.32 11.92 11.5014 11.92 12.96C11.92 14.4186 13.1014 15.6 14.56 15.6ZM14.56 16.92C12.7978 16.92 9.27997 17.8044 9.27997 19.56V20.88H19.84V19.56C19.84 17.8044 16.3222 16.92 14.56 16.92Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSavedCardIcon);
export default __webpack_public_path__ + "static/media/user_saved_card_icon.8140cd6b904d86ebc95e055bb9449dec.svg";
export { ForwardRef as ReactComponent };